import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES } from "../lib/images";
import { Reveal } from "../components/Reveal";
import { SEO } from "../components/SEO";

export default function About() {
  const { t } = useLanguage();
  return (
    <div data-testid="about-page">
      <SEO title="About — The Nice Picnic, Côte d'Azur"
        description="Born in Nice, The Nice Picnic is a house of experiences dedicated to the art of the picnic on the French Riviera — secret spots, Niçoise terroir, bohemian styling." />
      <section className="pt-36 pb-20 sm:pb-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-6">
            <Reveal>
              <p className="overline-label">{t("about.overline")}</p>
              <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ink mt-4 leading-tight">{t("about.title")}</h1>
              <div className="w-16 h-px bg-gold mt-6" />
              <p className="mt-8 text-earth font-light leading-relaxed text-lg">{t("about.p1")}</p>
              <p className="mt-5 text-earth font-light leading-relaxed">{t("about.p2")}</p>
              <p className="mt-5 font-serif italic text-xl text-clay">{t("about.p3")}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <ul className="mt-10 space-y-3">
                {t("about.values").map((v) => (
                  <li key={v} className="flex items-center gap-3 text-sm text-earth">
                    <span className="w-6 h-px bg-terracotta" /> {v}
                  </li>
                ))}
              </ul>
              <Link to="/booking" data-testid="about-book-btn" className="btn-primary mt-10">{t("hero.ctaBook")} <ArrowRight size={16} /></Link>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="md:col-span-5 md:col-start-8 grid gap-5">
            <div className="img-frame organic-crop">
              <img src={IMAGES.marina} alt="Mediterranean marina on the French Riviera" className="w-full h-72 object-cover" loading="lazy" />
            </div>
            <div className="img-frame organic-crop-alt md:-ml-10">
              <img src={IMAGES.beachClub} alt="Elegant beach club atmosphere on the Côte d'Azur" className="w-full h-64 object-cover" loading="lazy" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
